export default (state, action) => {
  const { node, description, url, title } = action.payload
  const type = node.content.type
  const current = {
    ...state.current,
    content: {
      ...node.content,
      description,
      title
    }
  }

  let allNodes

  if (type === 'task') {
    const media = {
      ...node.media,
      video: {
        ...node.media.video,
        url
      }
    }

    allNodes = state.allNodes.map(n => n.id === node.id
      ? { ...current, media }
      : n )

    return { ...state, current }
  }

  allNodes = state.allNodes.map(n => n.id === node.id
    ? current
    : n )

  return { ...state, current, allNodes }
}
